
import { API_ENDPOINTS } from './api-endpoints';
import { crudFactory } from './curd-factory';
import { HttpClientFront } from './http-client-front';
{/*
export const productClient = {
  ...crudFactory(API_ENDPOINTS.PRODUCTS),
  get({ slug, language }: GetParams) {
    return HttpClient.get(`${API_ENDPOINTS.PRODUCTS}/${slug}`, {
      language,
      with: 'type;shop;categories;tags;variations.attribute.values;variation_options;author;manufacturer;digital_file',
    });
  },
  paginated: ({
    type,
    name,
    categories,
    shop_id,
    ...params
  }) => {
    return HttpClient.get(API_ENDPOINTS.PRODUCTS, {
      searchJoin: 'and',
      with: 'shop;type',
      ...params,
      search: name
    });
  },
  popular({ shop_id, ...params }: Partial) {
    return HttpClient.get(API_ENDPOINTS.POPULAR_PRODUCTS, {
      searchJoin: 'and',
      with: 'type;shop',
      ...params,
      search: HttpClient.formatSearchParams({ shop_id }),
    });
  },
};
*/}

export const getScreenDetails = {
  
  ...crudFactory(API_ENDPOINTS.SCREENS),
  get:({ 
    id,
    ...params 
  }) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.SCREENS}/`+id, {
      ...params,
      
    });
  },
  all:(params ) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.SCREENS}`, params);
  },
};

export const getCreateScreenDetails = {
  
  ...crudFactory(API_ENDPOINTS.SCREENS),
  get:({ 
    id,
    ...params 
  }) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.SCREENS}/`+id, {
      ...params,
      
    });
  },
  all:(params ) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.SCREENS}/create/new`, params);
  },
};

export const follow_unfollow_screen = (data) => {
  return HttpClientFront.post("/follow_unfollow_screen", data);
};

